import * as React from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"

import { newsletterSection } from "./newsletterSignup.module.scss"

const NewsletterSignup = () => {
  const [email, setEmail] = React.useState("")
  const [message, setMessage] = React.useState("")

  const handleInputChange = event => {
    setEmail(event.target.value)
  }

  const handleSubmit = async event => {
    event.preventDefault()

    const result = await addToMailchimp(email)
    setMessage(result.msg);

    (typeof window !== "undefined" && window.gtag) &&
      window.gtag("event", "signup", {
        event_category: "newsletter",
        event_label: `${result.result}`,
        non_interaction: true
      })
  }

  return (
    <section className={`section ${newsletterSection}`}>
      <div className="container">
        <div className="columns m-0 has-text-centered is-centered has-text-white">
          <div className="column m-0 is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
            <h2 className="title is-3 has-text-white is-uppercase">
              Sign up today
            </h2>
            <p className="subtitle has-text-white">
              Sign up to get the latest on sales, new releases and more...
            </p>
            <form
              name="subscribeForm"
              method="POST"
              id="subscribe-form"
              className="has-text-white"
              action=""
              onSubmit={handleSubmit}
            >
              <div className="field is-grouped">
                <div className="control is-expanded">
                  <input
                    className="input"
                    type="email"
                    name="email"
                    placeholder="Enter your email address..."
                    value={email}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="control">
                  <button className="button is-danger is-light" type="submit">
                    Sign up
                  </button>
                </div>
              </div>
              <p
                className="help"
                dangerouslySetInnerHTML={{ __html: message }}
              ></p>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NewsletterSignup
